const Product = {
  log: window.log,

  init() {
    this.quantitySelector();
    this.subscriptionToggle();
    this.frequencySelector();
    this.updatePrice();
    this.addToCart();
    this.upsellATC();
    this.handleCartButton();
    this.handleReviewsSectionHeading();
  },

  productType: ($('#variants-data').data('product-type')).trim(),
  currency: ($('#variants-data').data('currency')).match(/[^\d.,\s]+/g)?.[0] || '£',
  hasVariants: $('#variants-data').data('has-variants') !== false,
  size: $('.pdp-main__product-option.size.active').data('size'),
  klarna: $('.pdp-main__klarna span'),
  upsellId: $('.pdp-main__upsell').data('id'),
  selectedSellingPlanId: null,
  useSubscription: true,
  selectedQuantity: $('.pdp-main__quantity-option.active').data('quantity') || 1,

  get selectedVar() {
    const baseQuery = '#variants-data .variant-data';
    if (!this.hasVariants) {
      return $(baseQuery);
    }
    const query = baseQuery + `${this.size ? `[data-size=\"${this.size}\"]` : ''}`;
    const selected = $(query);
    window.product_selected_variant = selected.length ? selected : $(baseQuery);
    return selected.length ? selected : $(baseQuery);
  },

  updatePrice() {
    const UPDATE_WITH_SUBS = false;
    const selectedVar = this.selectedVar;
    let basePrice = selectedVar.data('price') / 100;
    let comparePrice = selectedVar.data('compare-price') / 100 || basePrice;
    let finalPrice = basePrice;
    let saveAmount = 0;
    let savePercentage = 0;

    // Get subscription discount data once
    let subDiscount = 0;
    let subDiscountType = 'percentage';
    if (this.useSubscription && this.selectedSellingPlanId) {
      const $selectedPlan = $(`.selling-plan-data input[value="${this.selectedSellingPlanId}"]`);
      if ($selectedPlan.length) {
        subDiscountType = $selectedPlan.data('discount-type') || 'percentage';
        subDiscount = parseFloat($selectedPlan.data('discount')) || 0;
      }
    }

    // Step 1: Apply subscription discount first
    if (subDiscount > 0) {
      if (subDiscountType === 'percentage') {
        finalPrice = finalPrice * (100 - subDiscount) / 100;
        saveAmount = comparePrice - finalPrice;
        savePercentage = subDiscount;
        $('.pdp-main__frequency-discount-percentage').text(`${subDiscount}%`);
      } else if (subDiscountType === 'price') {
        finalPrice = parseFloat((subDiscount / 100).toFixed(2));
        saveAmount = parseFloat((comparePrice - finalPrice).toFixed(2));
        savePercentage = parseFloat((saveAmount / comparePrice * 100).toFixed(0));
        $('.pdp-main__frequency-discount-percentage').text(`${savePercentage}%`);
      } else {
        finalPrice = finalPrice - subDiscount;
        saveAmount = subDiscount;
        savePercentage = (subDiscount / comparePrice * 100);
        $('.pdp-main__frequency-discount-percentage').text(`${savePercentage}%`);
      }
    }

    // Step 3: Apply quantity discount to the subscription-adjusted price
    const $activeQty = $('.pdp-main__quantity-option.active');
    if ($activeQty.length) {
      this.selectedQuantity = parseInt($activeQty.data('quantity')) || 1;
      const qtyDiscount = parseFloat($activeQty.data('discount')) || 0;
      const qtyDiscountAmount = parseFloat($activeQty.data('saved-amount')) || 0;
      const qtyDiscountType = $activeQty.data('discount-type') || 'percentage';


      if (qtyDiscount > 0 || qtyDiscountAmount > 0) {
        if (qtyDiscountType === 'percentage') {
          finalPrice = finalPrice * (100 - qtyDiscount) / 100;
          saveAmount = comparePrice - finalPrice;
          savePercentage = qtyDiscount;
        } else {
          const discountInDollars = qtyDiscountAmount / 100;
          const totalPrice = finalPrice * this.selectedQuantity;
          finalPrice = (totalPrice - discountInDollars) / this.selectedQuantity;
          saveAmount = discountInDollars;
          savePercentage = (discountInDollars / (comparePrice * this.selectedQuantity) * 100);
        }
      }
    }

    // Calculate final totals
    finalPrice = (finalPrice * this.selectedQuantity).toFixed(2);
    const totalComparePrice = (comparePrice * this.selectedQuantity).toFixed(2);

    // Calculate final save amount and percentage from totals
    saveAmount = (parseFloat(totalComparePrice) - parseFloat(finalPrice)).toFixed(2);
    savePercentage = (parseFloat(saveAmount) / parseFloat(totalComparePrice) * 100).toFixed(2);

    // Update UI
    this.updateAddToCartButton(parseInt(selectedVar.data('stock')), !!selectedVar.data('available'));
    this.updateMainPriceDisplay(totalComparePrice, finalPrice, saveAmount, savePercentage);
    if (this.klarna.length > 0) this.klarna.text(`${this.currency}${(finalPrice / Number(this.klarna.data('divide'))).toFixed(2)}`);

    // Update quantity option prices
    $('.pdp-main__quantity-option').each((index, element) => {
      const $option = $(element);
      const quantity = parseInt($option.data('quantity')) || 1;
      const qtyDiscount = parseFloat($option.data('discount')) || 0;
      const qtyDiscountAmount = parseFloat($option.data('saved-amount')) || 0;
      const qtyDiscountType = $option.data('discount-type') || 'percentage';

      let pricePerQuantity = basePrice;
      let savedAmountPerQuantity = 0;
      let saveAmountFromSubs = 0;

      // Apply subscription discount
      if (subDiscount > 0) {
        if (subDiscountType === 'percentage') {
          pricePerQuantity = pricePerQuantity * (100 - subDiscount) / 100;
          saveAmountFromSubs = comparePrice - pricePerQuantity;
        } else if (subDiscountType === 'price') {
          pricePerQuantity = parseFloat((subDiscount / 100).toFixed(2));
          saveAmountFromSubs = comparePrice - pricePerQuantity;
        } else {
          pricePerQuantity = pricePerQuantity - subDiscount;
          saveAmountFromSubs = subDiscount;
        }
      }

      // Apply quantity discount
      if (qtyDiscount > 0 || qtyDiscountAmount > 0) {
        if (qtyDiscountType === 'percentage') {
          savedAmountPerQuantity = pricePerQuantity * qtyDiscount / 100;
          pricePerQuantity -= savedAmountPerQuantity;
        } else {
          const discountInDollars = qtyDiscountAmount / 100;
          const totalPrice = pricePerQuantity * quantity;
          pricePerQuantity = (totalPrice - discountInDollars) / quantity;
          savedAmountPerQuantity = discountInDollars / quantity;
        }
      }

      // Update displays
      const $priceElement = $option.find('.pdp-main__quantity-price:not(.single-variant)');
      const $saveElement = $option.find('.pdp-main__quantity-save');

      if ($priceElement.length) $priceElement.html(`${this.currency}${pricePerQuantity.toFixed(2)} `);
      if ($saveElement.length) {
        const totalSavedAmount = (savedAmountPerQuantity + (UPDATE_WITH_SUBS ? saveAmountFromSubs : 0)) * quantity;
        $saveElement.toggle(totalSavedAmount > 0).text(totalSavedAmount > 0 ? `Save ${this.currency}${totalSavedAmount.toFixed(2)}` : '');
      }
    });
  },

  updateMainPriceDisplay(originalPrice, discountedPrice, saveAmount, savePercentage) {
    const priceClass = '.pdp-main__prices:not(.pdp-main__upsell-prices)';
    const hasDiscount = parseFloat(saveAmount) > 0;

    // Update main prices (only if they exist)
    if ($(`${priceClass} s`).length) {
      $(`${priceClass} s`).toggleClass('hidden', !hasDiscount).text(`${this.currency}${originalPrice}`);
    }
    if ($(`${priceClass} h3`).length) {
      $(`${priceClass} h3`).text(`${this.currency}${discountedPrice}`);
    }
    if ($(`${priceClass} p`).length) {
      $(`${priceClass} p`).toggleClass('hidden', !hasDiscount).text(`Save ${this.currency}${saveAmount}`);
    }

    // Update subscription save percentage (only if it exists)
    if ($('.pdp-main__frequency-save-price').length) {
      $(`.pdp-main__frequency-save-price`).toggleClass('hidden', parseFloat(savePercentage) <= 0).text(`Save ${savePercentage}%`);
    }

    // Update ATC total price (only if it exists) - multiply by quantity
    if ($('.pdp-main__atc-total-price').length) {
      $('.pdp-main__atc-total-price').text(`${this.currency}${discountedPrice}`);
    }
  },

  updateAddToCartButton(stock, available) {
    if (stock <= 0 && !available) {
      $('.pdp-main__atc-btn').addClass('soldout').find('.pdp-main__atc-text').text('Sold Out');
    } else {
      const atcMainText = $('.pdp-main__atc-btn').find('.pdp-main__atc-text').data('main-text');
      $('.pdp-main__atc-btn').removeClass('soldout').find('.pdp-main__atc-text').text(atcMainText);
    }
  },

  quantitySelector() {
    $(document).on('click', '.pdp-main__quantity-option', (e) => {
      $('.pdp-main__quantity-option').removeClass('active');
      $(e.currentTarget).addClass('active');
      const quantityLabel = $(e.currentTarget).find('.pdp-main__quantity-name').text();
      if (quantityLabel) $('.pdp-main__product-variants-label span[data-type="quantity"]').text(`${quantityLabel}`);
      this.selectedQuantity = parseInt($(e.currentTarget).data('quantity')) || 1;
      // this.updateFrequencyStatus(); // Disable Sub option for more quantity than 1
      this.updatePrice();
    });
    // Set preselected as active by default
    const $quantityOptions = $('.pdp-main__quantity-option');
    let preselectedInd = +$('.pdp-main__quantity-options').data('preselected') || 1;
    preselectedInd = (preselectedInd > 0 && preselectedInd <= $quantityOptions.length) ? preselectedInd : 1;
    const $shouldBeActiveOption = $quantityOptions.eq(preselectedInd - 1);
    if ($shouldBeActiveOption.length) $shouldBeActiveOption.addClass('active');
  },

  subscriptionToggle() {
    $(document).on('change', '#subscription-toggle', (e) => {
      this.useSubscription = $(e.currentTarget).is(':checked');
      this.useSubscription
        ? $('.pdp-main__subscription-content').slideDown(300)
        : $('.pdp-main__subscription-content').slideUp(300);
      this.updatePrice();
    });
    // Set initial value
    this.useSubscription = $('#subscription-toggle').is(':checked');
  },

  updateFrequencyStatus() {
    // Disable frequency selector if quantity is greater than 1 
    // due to BUYQuantityOFFER discount codes not working with subs properly
    const isFrequencyDisabled = this.selectedQuantity > 1;
    $('.pdp-main__frequency.sub').toggleClass('disabled', isFrequencyDisabled);
    $('#subscription-toggle').prop('checked', !isFrequencyDisabled);
    this.useSubscription = !isFrequencyDisabled;
    this.useSubscription
      ? $('.pdp-main__subscription-content').slideDown(300)
      : $('.pdp-main__subscription-content').slideUp(300);
  },

  frequencySelector() {
    $(document).on('change', '.pdp-main__frequency-select', (e) => {
      this.selectedSellingPlanId = $(e.currentTarget).val();
      this.updatePrice();
    });
    const $initSelect = $('.pdp-main__frequency-select');
    if ($initSelect.length) this.selectedSellingPlanId = $initSelect.val();
  },

  addToCart() {
    $('.pdp-main__atc-btn, .pdp-sticky__button').click((e) => {
      e.preventDefault();
      const selectedVar = this.selectedVar;
      const id = selectedVar.data('id');
      let selling_plan = undefined;

      // Check if subscription toggle is enabled
      if (this.useSubscription && this.selectedSellingPlanId) {
        selling_plan = this.selectedSellingPlanId;
      }

      const quantity = this.selectedQuantity || 1;
      this.log.collapse({ selectedVar, id, selling_plan, quantity }, 'Adding to Cart', "warning")
      if (!id) return alert('Please select a product option.');

      $(e.currentTarget).hasClass('popup-upsell__trigger')
        ? this.handlePopupUpsell(selectedVar)
        : $.post('/cart/add.js', { items: [{ id, quantity, selling_plan }] })
          .done((cart) => { window.UPDATE_CART(); window.OPEN_CART(); })
          .fail((e) => this.log.collapse({ e }, 'Error adding item to cart.', "error"));
    });
  },

  upsellATC() {
    const upsellAtcButton = $('.pdp-main__upsell-atc');
    upsellAtcButton.on('click', (e) => {
      e.preventDefault();
      upsellAtcButton.disabled = true;
      const upsellId = this.upsellId || upsellAtcButton.data('id');
      this.log.collapse({ upsellId }, 'UPSELL: Adding to Cart', "warning");

      $.post('/cart/add.js', { items: [{ id: upsellId, quantity: 1 }] })
        .done((cart) => { window.UPDATE_CART(); window.OPEN_CART(); })
        .fail((e) => this.log.collapse({ e }, 'Error adding item to cart.', "error"))
        .always(() => upsellAtcButton.disabled = false);
    });
  },

  handleCartButton() {
    $('.product_form .cart_button').on('click', (e) => {
      e.preventDefault();
      const selectedVar = this.selectedVar;
      const quantity = $('form.pro_quantity input[name="quantity"]').val();
      const id = selectedVar.data('id');

      $.post('/cart/add.js', { items: [{ id, quantity }] })
        .done((cart) => { window.UPDATE_CART(); window.OPEN_CART(); })
        .fail((e) => this.log.collapse({ e }, 'Error adding item to cart.', "error"));
    });
  },

  handlePopupUpsell(selectedVar) {
    const popup = $('.popup-upsell');
    const upsellAtcButton = popup.find('.popup-upsell__atc-btn');
    const originalId = selectedVar.data('id');
    const totalPrice = (Number(selectedVar.data('price')) + Number(upsellAtcButton.data('price'))) / 100;

    popup.find('.popup-upsell__atc-price').text(`${this.currency}${totalPrice.toFixed(2)}`);
    popup.addClass('active');

    // Start the timer if it exists
    if (window.popupUpsellTimer) window.popupUpsellTimer.start();

    const closePopupAndAddToCart = (items) => {
      // Stop timer if it exists
      if (window.popupUpsellTimer) {
        window.popupUpsellTimer.stop();
      }
      popup.removeClass('active');

      $.post('/cart/add.js', { items })
        .done((cart) => { window.UPDATE_CART(); window.OPEN_CART(); })
        .fail((e) => this.log.collapse({ e }, 'Error adding items to cart.', "error"));
    };

    // Remove any existing click handlers
    upsellAtcButton.off('click');
    popup.find('.popup-upsell__decline').off('click');

    // Add new click handlers
    upsellAtcButton.on('click', () => {
      closePopupAndAddToCart([
        { id: originalId, quantity: 1 },
        { id: upsellAtcButton.data('id'), quantity: 1 }
      ]);
    });

    popup.find('.popup-upsell__decline').on('click', () => {
      closePopupAndAddToCart([{ id: originalId, quantity: 1 }]);
    });
  },

  handleReviewsSectionHeading() {
    const badge = $(".judgeme-count-wrapper .jdgm-prev-badge").clone();
    const textPrepend = "<span>Rated 4.9 / 5 by </span>";
    const textAppend = "<span> Pet Parents</span>";
    badge
      .css({
        display: "flex",
        "flex-wrap": "wrap",
      })
      .find(".jdgm-prev-badge__stars")
      .css({
        display: "flex",
        gap: "2px",
      });
    const tpRatingsCount = $('.judgeme-count-container').html();
    const badgeText = badge.find(".jdgm-prev-badge__text")
    if (tpRatingsCount && tpRatingsCount.trim() !== "") badgeText.html(tpRatingsCount);
    badgeText.before(textPrepend).after(textAppend).css("padding-left", "0");

    const countContainer = $(".testimonial_heading .subheading");
    if (countContainer.length && badge.length) countContainer.empty().append(badge);
  },
};

$(document).ready(function () {
  Product.init();
});